// THE SELF-SERVICE COLUMN WHILE ITS BOOKING LOADS.
//
// Freddi, 2026-10-11: "we should have the proper booking modal loading
// skeleton structure that should not change, it should just load the contents
// after the skeleton". The column is the request card, shut, and on an app
// booking the Money card's head under it — so that is what the skeleton draws,
// in the cards' own classes and the cards' own frame. When the booking lands
// the words arrive in place and nothing moves; before, the column drew the old
// App access column and visibly changed shape into the self-service one.
// No pill in the head (Freddi, 2026-10-11: "remove the empty pill in the top
// right corner … it's not necessary"): the state is a word that arrives with
// the booking; an outline waiting for it read as a thing in itself.
import { PeopleSkeleton } from './RequestCard';

const bar = (w: number | string, h: number) => <span className="bl-block" style={{ display: 'inline-block', width: w, height: h, verticalAlign: 'middle' }} />;

function Head({ money }: { money: boolean }) {
  return (
    <div className={`rq${money ? ' money' : ''} is-desk is-skeleton`}>
      <div className="rq-top">
        <span className="rq-title">{bar(money ? 56 : 92, 14)}</span>
        <span className="rq-sub">{bar('68%', 10)}</span>
      </div>
      {/* The shut request card names the household (2026-10-11): the same row, empty, so nothing moves when it fills. */}
      {!money && <div className="rq-access"><PeopleSkeleton /></div>}
    </div>
  );
}

export function SelfServiceSkeleton() {
  return (
    <aside className="ob-access" aria-busy="true">
      <Head money={false} />
      {/* The Money card is on every booking (2026-10-11), so its head is in every skeleton — and the
          Vaccinations card's under it (vaccination-cards AC13), the same head in the same frame. */}
      <Head money />
      <Head money />
    </aside>
  );
}
